/*
 * @Author: dgq 370541946@qq.com
 * @Date: 2025-04-22 15:22:48
 * @FilePath: /insuranceagent-ui/src/util/userLog.js
 * @Description: 获取保单是否已下载 PDF
 */

import {getUserLogs} from '@/api/admin/log'
import {EnumLogType} from '@/const/enum'

/**
 * 获取保单下载状态  批单，发票页面
 * @param {Object} response 响应数据
 * @param {Array} fileType 文件类型
 * @param {Array} keys 键名
 * @returns {Array} 保单下载状态
 */
export async function getPolicyLogListObj(response = {}, fileType = ['保单', '批单', '发票'], ...keys) {
	//处理数据
	let {code = -1, data} = response.data || {}
	if (code !== 0) {
		return []
	}
	//如果data 是对象，则取值records，如果为集合，则取值data
	let records = Array.isArray(data) ? data : data.records || []
	return getPolicyLogList(records, fileType, ...keys)
}

/**
 * 获取保单详情下载keys
 * @param {Array} pdfDataList 保单详情数据列表
 * @returns {Array} 保单详情下载keys
 */
export function getPolicyDetailLogKeys(pdfDataList = []) {
	//处理数据
	let allKeyList = []
	for (let i = 0; i < pdfDataList.length; i++) {
		let itemData = pdfDataList[i]
		let {label = '', value = []} = itemData
		//循环获取keys
		let tempNoList = getPolicyDownloadKeys(value, [`${label}`], 'endorseNo', 'policyNo') || []
		allKeyList.push(...tempNoList)
	}
	return allKeyList
}

/**
 * 获取保单下载状态 保单详情的
 * @param {Object} response 响应数据
 * @param {Array} fileType 文件类型
 * @param {Array} keys 键名
 * @returns {Array} 保单下载状态
 */
export async function getPolicyDetailLogListObj(pdfDataList = []) {
	//处理数据
	let allKeyList = getPolicyDetailLogKeys(pdfDataList)
	if (allKeyList.length <= 0) {
		return pdfDataList
	}
	//调用接口获取是否下载
	let resData = await getUserLogs(EnumLogType.logPolicyPdfDownload, {eventStatus: '1', eventKeys: allKeyList})
	let {code: codeLog = -1, data: recordsLog = []} = resData.data || {}
	if (codeLog !== 0 || recordsLog.length <= 0) {
		return pdfDataList
	}
	recordsLog.forEach((itemLog) => {
		let {eventKey = '', eventStatus = ''} = itemLog
		if (eventStatus === 1) {
			pdfDataList.forEach(({label = '', value = []}) => {
				let tempData = value.find(({endorseNo, policyNo}) => eventKey === `${label}_${endorseNo || policyNo}`)
				if (tempData) {
					tempData.isDownload = true
				}
			})
		}
	})
	return pdfDataList
}

/**
 * 获取事件keys
 * @param {Array} dataList 数据列表
 * @param {Array} fileType 文件类型
 * @param {Array} keys 键名
 * @returns {Array} 事件keys
 */
export function getPolicyDownloadKeys(dataList = [], fileType = [], ...keys) {
	let tempNoList = []
	if (keys.length <= 0) {
		return tempNoList
	}
	//通过dataList 和 keys  获取数据
	for (let i = 0; i < dataList.length; i++) {
		let itemData = dataList[i]
		fileType.forEach((fileTypeItem) => {
			//保单只取有值的 批单在前 保单在后
			let tempKey = keys.find((key) => itemData[key])
			if (tempKey) {
				tempNoList.push(`${fileTypeItem}_${itemData[tempKey]}`)
			}
		})
	}
	return tempNoList
}

/**
 * 获取记录列表   只处理特殊情况，比如 保单', '批单', '发票
 * @param {Array} dataList 数据列表
 * @param {Array} fileType 文件类型
 * @param {Array} keys 键名
 * @returns {Array} 记录列表
 */
export async function getPolicyLogList(dataList = [], fileType = ['保单', '批单', '发票'], ...keys) {
	try {
		if (keys.length <= 0) {
			return dataList
		}
		let tempNoList = getPolicyDownloadKeys(dataList, fileType, ...keys)
		if (tempNoList.length <= 0) {
			return dataList
		}
		//调用接口获取是否下载
		let resData = await getUserLogs(EnumLogType.logPolicyPdfDownload, {eventStatus: '1', eventKeys: tempNoList})
		let {code: codeLog = -1, data: recordsLog = []} = resData.data || {}
		if (codeLog !== 0) {
			return dataList
		}
		//循环fileType
		for (let i = 0; i < fileType.length; i++) {
			let fileTypeItem = fileType[i]
			recordsLog.forEach((itemLog) => {
				let {eventKey = ''} = itemLog
				let tempData = dataList.find(({endorseNo, policyNo}) => eventKey === `${fileTypeItem}_${endorseNo || policyNo}`)
				if (tempData) {
					//使用this.$set 设置 当前文件为js
					tempData.isDownload = true
				}
			})
		}
		return dataList
	} catch (error) {
		throw error
	}
}
